import { normalizeLocationInfo } from '@utils/storeDataNormalization';
import factory from '@helpers/storeFactories/factory';
import { apiServiceLocations } from '@api';
import storeConstants from '@/utils/constants/store';

const STORE_NAME = 'countriesWithHotels';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceLocations.locations.countries.getWithHotels,
    },
    {
        statePath: 'countries.countriesWithHotels',
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: true,
                    offset: 0,
                    limit: 1000,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        customListFormatter: normalizeLocationInfo,
    },
    {
        getters: {
            getList: (state) => state.list,
            getOneByCodeOrName:
                (state) =>
                (itemFind, findOptions = { code: true }) =>
                    state.list.find((item) =>
                        findOptions.code ? item.code === itemFind : item.name === itemFind
                    ),
        },
    }
);

export default store;
